import React from 'react';
import { useTranslation } from 'react-i18next';

/** Küçük "Pro" rozeti; Pro özellik kilitliyken buton/link yanında gösterilir. */
export default function ProTag() {
  const { t } = useTranslation();
  return (
    <span
      className="ml-0.5 px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-primary-100 dark:bg-primary-900/50 text-primary-600 dark:text-primary-400"
      title={t('proFeature.requiresPro')}
    >
      Pro
    </span>
  );
}
